import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'carbon-components-react';
import { MovementOfGoods_01 as MovementOfGoods } from '@carbon/pictograms-react';

export const ChannelsNoData: React.FC<Props> = ({
  onClickSandboxHandler
}: Props) => {
  return (
    <div className="channel-no-data--wrapper">
      <MovementOfGoods />
      <h2 className="channel-no-data--header-text">
        There is no active channel yet
      </h2>
      <p className="channel-no-data--body-text">
        Channel types include Email, Web Hook and SmarterWX Automate
      </p>
      <hr className="section--divider" />
      <Button onClick={() => onClickSandboxHandler(true)}>
        Set up a channel in the Sandbox
      </Button>
    </div>
  );
};

const propTypes = {
  onClickSandboxHandler: PropTypes.func.isRequired
};

type Props = PropTypes.InferProps<typeof propTypes>;

ChannelsNoData.propTypes = propTypes;

ChannelsNoData.defaultProps = {
  onClickSandboxHandler: () => {}
};

export default ChannelsNoData;
